import { Injectable } from '@angular/core';
import { IQuotationsQuotation } from 'libraries/service/resources/quotation-quotations/IQuotationsQuotation';
import { InstanceService } from 'libraries/service/instance/instance.service';

@Injectable()
export class WatabiUrlService {
    public constructor(private readonly instanceService: InstanceService) {

    }

    public generateFrontendQuoteUrl(quotation: IQuotationsQuotation): string {
        if (quotation.externalReference.detail) {
            const idItem: number = quotation.externalReference.detail.booking.idItem;
            const idVersion: number = quotation.externalReference.detail.booking.idVersion;

            const quotationIdItemParam: string = `#quotes_${quotation.externalReference.detail.quotation.idItem}`;
            return `${this.instanceService.fullUrl}wui_watabi/item/${idItem}/${idVersion}/${quotationIdItemParam}`;
        }


        // Compatibility with previous quotations
        return `${this.instanceService.fullUrl}wui_watabi/item/${quotation.externalReference.code}`;
    }
}